import React from 'react';
import { usePlateWellActions, useSelecetedAnalysisType } from '../../../store/plateWellStore';
import ReplicateAnalysis from './ReplicateAnalysis';
import SelectDropDown from '../../common/ReactHookForm/SelectDropDown';
import ControlExperimentAnalysis from './ControlExperimentAnalysis';
import AnalysisResult from '../../common/TabPanel/AnalysisResult';
import { Analysis, AnalysisOptions } from '../../constants/analysisType';


const AnalysisSetUp = () => {

    const { setSelectedAnanlysisType, setTabValue } = usePlateWellActions();
    const selectedAnalysisType = useSelecetedAnalysisType();

    // Tried to render the component based off selectedAnalysisType, but it doesn't work - browser recognizes the value as a string.
    // const ComponentToRender = AnalysisTypes.find(item => item.value === selectedAnalysisType).label;
    // then just render this ComponentToRender

    const handleSelectedAnalysisType = (e) => {

        setSelectedAnanlysisType(e.target.value)
        if (e.target.value === Analysis.singlewell) {
            setTabValue("tab4");
        }


    }
    return (

        <div className='plate-edit-setup'>
            <h4 className='font-bold pb-4'> Analysis SetUp</h4>
            <SelectDropDown className={`selectDropDown border border-gray-300 px-4 py-2 rounded-md font-bold `}
                options={AnalysisOptions} defaultValue={selectedAnalysisType ? selectedAnalysisType : AnalysisOptions[0].value} name="Numerical Analysis"
                onChange={handleSelectedAnalysisType} />


            {selectedAnalysisType === Analysis.replicate ? <ReplicateAnalysis /> :
                // selectedAnalysisType === Analysis.singlewell ? <AnalysisResult /> :
                selectedAnalysisType === Analysis.controlexp ? <ControlExperimentAnalysis /> : null}
        </div>


    );
}

export default AnalysisSetUp;